"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var clone = require('clone');
var tv4 = require('tv4');
var Recipient = require('./recipient');
var Email = /*#__PURE__*/function () {
  function Email(opt) {
    _classCallCheck(this, Email);
    this.toRecipients = [];
    this.ccRecipients = [];
    this.bccRecipients = [];
    this.sendDate = null;
    this.templateLabel = null;
    this.templateParams = {};
    this.notificationId = null;
    this.immediate = false;
    this.replyTo = null;
    if (opt && opt.details) {
      this.fillObject(clone(opt.details));
    }
  }
  _createClass(Email, [{
    key: "fillObject",
    value: function fillObject(opt) {
      var _this = this;
      if (opt.toRecipients) {
        opt.toRecipients.forEach(function (toRecipient) {
          return _this.toRecipients.push(new Recipient(toRecipient));
        });
      }
      if (opt.ccRecipients) {
        opt.ccRecipients.forEach(function (ccRecipient) {
          return _this.ccRecipients.push(new Recipient(ccRecipient));
        });
      }
      if (opt.bccRecipients) {
        opt.bccRecipients.forEach(function (bccRecipient) {
          return _this.bccRecipients.push(new Recipient(bccRecipient));
        });
      }
      this.sendDate = new Date(opt.sendDate);
      this.templateLabel = opt.templateLabel;
      this.templateParams = opt.templateParams;
      this.notificationId = opt.notificationId || null;
      this.immediate = opt.immediate || false;
      this.replyTo = opt.replyTo || null;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, Email.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'email.schema.json',
        type: 'object',
        properties: {
          toRecipients: {
            type: 'array',
            items: {
              $ref: 'recipient.schema.json'
            }
          },
          ccRecipients: {
            type: 'array',
            items: {
              $ref: 'recipient.schema.json'
            }
          },
          bccRecipients: {
            type: 'array',
            items: {
              $ref: 'recipient.schema.json'
            }
          },
          sendDate: {
            type: 'object'
          },
          templateLabel: {
            type: 'string'
          },
          templateParams: {
            type: 'object'
          },
          notificationId: {
            type: ['string', 'null']
          },
          immediate: {
            type: 'boolean'
          },
          replyTo: {
            type: ['string', 'null']
          }
        },
        required: Object.keys(this)
      };
    }
  }]);
  return Email;
}();
tv4.addSchema(Recipient.schema());
module.exports = Email;